import React, { useState } from "react"
import { usePublicItemDistributions } from "popopo-lib-front"
import { api, firestore } from "../core"
import { Spinner, Button } from "react-bootstrap"
import { useToast } from "popopo-lib-front/hook"
import { useAccessContext } from "../component/guard/AccessGuard"
import { Paths } from "../paths"
import { usePathParams } from "popopo-lib-front/hook/path"
import { ShareImageDownloadButton } from "../component/ShareImageDownloadButton"

export const Item = () => {
  const { itemId } = usePathParams(Paths.items.item)
  const distributions = usePublicItemDistributions(firestore, itemId)
  const context = useAccessContext()
  const toast = useToast()
  const [purchasingDistId, setPurchasingDistId] = useState<string | null>(null)

  if (distributions === "loading") {
    return <Spinner/>
  }

  const handlePurchase = async (distributionId: string, price: number) => {
    setPurchasingDistId(distributionId)
    try {
      const idToken = await context.credential.user.getIdToken()
      const result = await api.POST("/api/v2/users/me/user-inventories/{itemId}", {
        params: { path: { itemId: itemId } },
        headers: {
          authorization: `Bearer ${idToken}`,
        },
        body: {
          kind: "purchase",
          itemDistributionId: distributionId,
          price: price,
        },
      })
      if (result.error) {
        toast.add({ type: "danger", title: "購入エラー", message: `購入に失敗しました。${JSON.stringify(result.error)}` })
      } else {
        toast.add({ type: "success", title: "購入完了", message: "アイテムを購入しました" })
      }
    } catch (error) {
      toast.add({ type: "danger", title: "購入エラー", message: "購入に失敗しました" })
      console.error(error)
    } finally {
      setPurchasingDistId(null)
    }
  }

  return (<>
    <div className="row mt-5 gy-5 justify-content-center">
      <h2>アイテム販売情報</h2>
      <div>
        <ShareImageDownloadButton
          getIdToken={() => context.credential.user.getIdToken()}
          path={`/api/v2/shop/items/${itemId}/share-image`}
          filename={`item-${itemId}-share-image.png`}
          label="商品共有画像DL"
        />
      </div>
      <div className="row row-cols-1 row-cols-md-3 g-4">
        {distributions.map(itemDistribution => (
          <div className="col" key={itemDistribution.id}>
            <div className="card h-100">
              <div className="card-body">
                <h5 className="card-title">{itemDistribution.name}</h5>
                <p className="card-text">{itemDistribution.description}</p>
                <p className="card-text">価格: {itemDistribution.price !== null ? `${itemDistribution.price} コイン` : "アイテム価格を参照"}</p>
                <p className="card-text">status: {itemDistribution.status}</p>
                <p className="card-text">start_at : {new Date(itemDistribution.start_at).toLocaleString()}</p>
                <p className="card-text">finish_at: {itemDistribution.finish_at ? new Date(itemDistribution.finish_at).toLocaleString() : "無期限"}</p>
                <Button
                  variant="primary"
                  onClick={() => itemDistribution.price !== null && handlePurchase(itemDistribution.id, itemDistribution.price)}
                  disabled={purchasingDistId !== null || itemDistribution.price === null}
                  className="w-100"
                >
                  {purchasingDistId === itemDistribution.id ? "購入中..." : "購入"}
                </Button>
              </div>
              <div className="card-footer">
                <small className="text-muted">Last updated {new Date(itemDistribution.updated_at).toLocaleString()}</small>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </>)
}
